export let NotificationItemType = /*#__PURE__*/function (NotificationItemType) {
  NotificationItemType["STANDARD"] = "standard";
  NotificationItemType["SUCCESS"] = "success";
  NotificationItemType["ERROR"] = "error";
  NotificationItemType["WARNING"] = "warning";
  NotificationItemType["INFO"] = "info";
  return NotificationItemType;
}({});
export const defaultNotificationLife = 3000;
export const defaultNotificationPersist = false;
export const defaultNotificationType = NotificationItemType.STANDARD;